<template>
  <span class="kui-textinput" :class='{"direction": !options.isVertical}' :ref='options.field'>
    <span v-show="options.title" class="kui-textinput-title"
      :class="{'required-must':options.required}">{{titleName}}</span>
    <kui-validatebox ref='validatebox' :options='options'>
      <el-input :placeholder="placeholder" :disabled="disabled" :clearable="options.clearable || ''" v-model="value"
        slot="validatebox-content" :class='{"validate-must":!isPassValidate,"has-button": options.buttonText}'
        @blur="validate(value)" @input.native='valChange(value)'>
      </el-input>
    </kui-validatebox>
    <el-button v-if="options.buttonText" :disabled="options.btnDisabled" @click="onButtonClick">
      {{options.buttonText}}
    </el-button>
  </span>
</template>
<script>
import textinput from "./src/textinput";
export default textinput;

</script>
<style lang='less'>
.kui-textinput {
  align-items: center;
  display: flex;
  padding: 8px;
  &.direction {
    display: inline-flex;
  }
  .kui-textinput-title {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #343434;
    padding: 0 5px 0 0;
    box-sizing: border-box;
    position: relative;
  }
  .kui-textinput-title.required-must:before {
    content: "*";
    color: #f56c6c;
    display: inline-block;
    position: absolute;
    line-height: 110%;
    left: -10px;
  }
  .has-button {
    input {
      border-radius: 4px 0px 0px 4px;
    }
  }
  .el-button {
    margin-left: -1px;
    border-radius: 0 4px 4px 0;
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/textinput/index.vue